export default "__VITE_ASSET__231d7a8c__"